'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import styles from './StickyMobileCta.module.scss';
import { IconPhone } from '@tabler/icons-react';
import { gaCta } from '@/src/helpers/gtag';

const HIDDEN_PATHS = ['/admin', '/jarvis', '/login', '/client', '/super-admin', '/nda'];

export function StickyMobileCta({ label, href }: { label: string; href: string }) {
  const pathname = usePathname() ?? '';
  const normalized = pathname.replace(/^\/[a-z]{2}/, ''); // strip /fr or /en

  const isHidden = HIDDEN_PATHS.some((p) => normalized.startsWith(p));
  if (isHidden) {
    return null;
  }

  return (
    <div className={styles.root}>
      <Link
        href={href}
        className={styles.button}
        onClick={() => gaCta(label, 'sticky_mobile_cta', href)}
      >
        <IconPhone size={18} aria-hidden="true" />
        <span>{label}</span>
      </Link>
    </div>
  );
}
